import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';

export interface CustomerIsExemptFromBillingFilterStateControllerProps {
  value: GatewayCustomerModel['isExemptFromBilling'];
  onRemove: FilteredItemProps['onRemove'];
}

export const CustomerIsExemptFromBillingFilterStateController = ({
  value,
  onRemove,
}: CustomerIsExemptFromBillingFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="currency-euro-circle"
      label={`${value}`}
      onRemove={onRemove}
    />
  );
};
